module.exports = __webpack_public_path__ + "static/media/SujoyaDey@2x.7081130d.png";